import React from 'react'
import ContactUs from '../../sections/ContactUs'
import Layout from '../../component/layout/Layout'

export default function index() {
  return (
    <Layout>
  <div className="py-4">

  <ContactUs/>
  </div>
  </Layout>
  )
}
